export enum CoverType {
  Comprehensive = 'COMPREHENSIVE',
  Vaps = 'VAPS',
}
